module.exports = __webpack_public_path__ + "static/media/landd.9ffb3397.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/landd.png
// module id = 889
// module chunks = 0